// import React from "react";
// import {
//   Box,
//   Typography,
//   Grid,
//   Card,
//   CardContent,
//   CardMedia,
//   Stack,
// } from "@mui/material";
// import chatImage from "./firstCardImg.gif"; // Replace with actual image path
// import analyticsImage from "./secondCardImg.gif"; // Replace with actual image path

// const Section11B1 = () => {
//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: {
//           xl: "row",
//           lg: "row",
//           md: "column",
//           sm: "column",
//           xs: "column",
//         },
//         alignItems: "center",
//         px: { xs: 2, md: 5 },
//         py: 4,
//         gap: 2,
//       }}
//     >
//       {/* <Grid
//         container
//         spacing={4}
//         sx={{
//           maxWidth: "1200px",
//           margin: "0 auto",
//           justifyContent: { xs: "center", md: "space-between" },
//           flexDirection: { xs: "column", md: "row" }, // Stack cards for mobile, row for larger screens
//           border: "1px solid red",
//         }}
//       > */}

//       {/* First Card - Adjusted for Mobile */}
//       <Card
//         sx={{
//           display: "flex",
//           flexDirection: "column", // Stacked layout for mobile
//           alignItems: "center",
//           boxShadow: "none",
//           border: "1px solid #E0E0E0",
//           padding: "16px",
//           backgroundColor: "#F9F9FF",
//           height: { xs: "auto", xl: "100%" }, // Auto height for mobile, full height for larger screens
//           width: { xs: "80%" },
//           textAlign: { xs: "center", md: "left" }, // Center-align text for mobile
//         }}
//       >
//         <CardContent
//           sx={{
//             width: "100%",
//             paddingBottom: "16px",
//           }}
//         >
//           <Typography
//             variant="h5"
//             sx={{
//               fontWeight: "bold",
//               marginBottom: "8px",
//               textAlign: { xs: "center", md: "left" }, // Center-align for mobile
//             }}
//           >
//             Real-Time Analytics
//           </Typography>
//           <Typography
//             variant="body2"
//             sx={{
//               marginBottom: "16px",
//               textAlign: { xs: "center", md: "left" }, // Center-align for mobile
//             }}
//           >
//             Track your campaign results in real-time.
//           </Typography>
//           <Typography
//             variant="body2"
//             sx={{
//               marginBottom: "16px",
//               textAlign: { xs: "center", md: "left" }, // Center-align for mobile
//             }}
//           >
//             Monitor Read, Replied & Clicked rates for each campaign and retarget
//             smartly for higher conversions!
//           </Typography>
//         </CardContent>
//         <CardMedia
//           component="img"
//           image={chatImage}
//           alt="Build no-code Chatbot"
//           sx={{
//             width: "100%",
//             height: "auto",
//             borderRadius: "8px",
//             marginTop: { xs: "16px", md: "0" }, // Add margin on mobile for spacing
//           }}
//         />
//       </Card>

//       {/* Second Card */}

//       <Card
//         sx={{
//           display: "flex",
//           flexDirection: "column", // Stacked layout for mobile
//           alignItems: "center",
//           boxShadow: "none",
//           border: "1px solid #E0E0E0",
//           padding: "16px",
//           backgroundColor: "#F9F9FF",
//           height: { xs: "auto", xl: "100%" }, // Auto height for mobile, full height for larger screens
//           width: { xs: "80%" },
//           textAlign: { xs: "center", md: "left" },
//         }}
//       >
//         <CardContent
//           sx={{
//             width: "100%",
//             paddingBottom: "16px",
//           }}
//         >
//           <Typography
//             variant="h5"
//             sx={{
//               fontWeight: "bold",
//               marginBottom: "8px",
//               textAlign: { xs: "center", md: "left" }, // Center-align for mobile
//             }}
//           >
//             Real-Time Analytics
//           </Typography>
//           <Typography
//             variant="body2"
//             sx={{
//               marginBottom: "16px",
//               textAlign: { xs: "center", md: "left" }, // Center-align for mobile
//             }}
//           >
//             Track your campaign results in real-time.
//           </Typography>
//           <Typography
//             variant="body2"
//             sx={{
//               marginBottom: "16px",
//               textAlign: { xs: "center", md: "left" }, // Center-align for mobile
//             }}
//           >
//             Monitor Read, Replied & Clicked rates for each campaign and retarget
//             smartly for higher conversions!
//           </Typography>
//         </CardContent>
//         <CardMedia
//           component="img"
//           image={chatImage}
//           alt="Build no-code Chatbot"
//           sx={{
//             width: { xs: "90%", md: "80%" }, // Responsive width
//             height: { xs: "auto", md: "60%" }, // Responsive height
//             borderRadius: "8px",
//             marginTop: { xs: "16px", md: "0" }, // Add margin on mobile for spacing
//           }}
//         />
//       </Card>

//       {/* </Grid> */}
//     </Box>
//   );
// };

// export default Section11B1;
import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Stack,
} from "@mui/material";
import chatImage from "./firstCardImg.gif"; // Replace with actual image path
import analyticsImage from "./secondCardImg.gif"; // Replace with actual image path

const Section11A1 = ({ data, index }) => {
  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        justifyContent: "center",
        marginTop: "16px",
      }}
    >
      <Stack
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: {
              xl: "row",
              lg: "row",
              md: "row",
              sm: "row",
              xs: "column",
            },
            // border: "2px solid red",
            width: { md: "92%", sm: "94%", xs: "94%" },
            gap: 2,
          }}
        >
          <Card
            sx={{
              display: "flex",
              flexDirection: "column", // Stacked layout for mobile
              alignItems: "center",
              boxShadow: "none",
              border: "1px solid #E0E0E0",
              // padding: "16px",
              backgroundColor: "#F9F9FF",
              // height: { xs: "auto", xl: "100%" }, // Auto height for mobile, full height for larger screens
              // width: { xs: "80%" },
              textAlign: { xs: "left", md: "left" },
            }}
          >
            <CardContent
              sx={{
                width: "100%",
                // paddingBottom: "16px",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  marginBottom: "8px",
                  textAlign: { xs: "left", md: "left" }, // Center-align for mobile
                  fontFamily: "'Roboto', sans-serif",
                  fontSize: {
                    xs: "20px",
                  },
                  lineHeight: {
                    xs: "24px",
                  },
                  fontWeight: 600,
                  color: "rgb(5 78 146)",
                }}
              >
                {/* Feature 3 */}
                {data[index]?.features[2]?.title || "title"}
              </Typography>
              {/* <Typography
                variant="body2"
                sx={{
                  marginBottom: "16px",
                  textAlign: { xs: "left", md: "left" }, // Center-align for mobile
                }}
              >
                Track your campaign results in real-time.
              </Typography> */}
              <Typography
                variant="body2"
                sx={{
                  marginBottom: "16px",
                  textAlign: { xs: "left", md: "left" }, // Center-align for mobile
                  fontFamily: "'Roboto', sans-serif",
                  fontSize: {
                    xs: "16px",
                  },
                  lineHeight: {
                    xs: "20px",
                  },
                  fontWeight: 400,
                  color: "#333",
                }}
              >
                {/* Monitor Read, Replied & Clicked rates for each campaign and
                retarget smartly for higher conversions! */}
                {data[index]?.features[2]?.description2 || "description"}
              </Typography>
            </CardContent>
            <CardMedia
              component="img"
              // image={chatImage}
              image={data[index]?.features[2]?.img || chatImage}
              alt="Build no-code Chatbot"
              sx={{
                width: { xs: "90%", md: "80%" }, // Responsive width
                height: { xs: "auto", md: "60%" }, // Responsive height
                borderRadius: "8px",
                marginTop: { xs: "16px", md: "0" }, // Add margin on mobile for spacing
              }}
            />
          </Card>

          <Card
            sx={{
              display: "flex",
              flexDirection: "column", // Stacked layout for mobile
              alignItems: "center",
              boxShadow: "none",
              border: "1px solid #E0E0E0",
              backgroundColor: "#F9F9FF",
              textAlign: { xs: "center", md: "left" },
            }}
          >
            <CardContent
              sx={{
                width: "100%",
                // paddingBottom: "16px",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  marginBottom: "8px",
                  textAlign: { xs: "left", md: "left" }, // Center-align for mobile
                  fontFamily: "'Roboto', sans-serif",
                  fontSize: {
                    xs: "20px",
                  },
                  lineHeight: {
                    xs: "24px",
                  },
                  fontWeight: 600,
                  color: "rgb(5 78 146)",
                  // border: "2px solid blue",
                }}
              >
                {/* Feature 4 */}
                {data[index]?.features[3]?.title || "title"}
              </Typography>
              {/* <Typography
                variant="body2"
                sx={{
                  marginBottom: "16px",
                  textAlign: { xs: "left", md: "left" }, // Center-align for mobile
                }}
              >
                Track your campaign results in real-time.
              </Typography> */}
              <Typography
                variant="body2"
                sx={{
                  marginBottom: "16px",
                  textAlign: { xs: "left", md: "left" }, // Center-align for mobile
                  fontFamily: "'Roboto', sans-serif",
                  fontSize: {
                    xs: "16px",
                  },
                  lineHeight: {
                    xs: "20px",
                  },
                  fontWeight: 400,
                  color: "#333",
                }}
              >
                {/* Monitor Read, Replied & Clicked rates for each campaign and
                retarget smartly for higher conversions! */}
                {data[index]?.features[3]?.description2 || "description"}
              </Typography>
            </CardContent>
            <CardMedia
              component="img"
              // image={chatImage}
              image={data[index]?.features[3]?.img || chatImage}
              alt="Build no-code Chatbot"
              sx={{
                width: { xs: "90%", md: "80%" }, // Responsive width
                height: { xs: "auto", md: "60%" }, // Responsive height
                borderRadius: "8px",
                marginTop: { xs: "16px", md: "0" }, // Add margin on mobile for spacing
              }}
            />
          </Card>
        </Box>
      </Stack>
    </Stack>
  );
};

export default Section11A1;
